/* unplugin-vue-components disabled */import { render } from "./Timer.vue?vue&type=template&id=051164d8&scoped=true&ts=true"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"

import "./Timer.vue?vue&type=style&index=0&id=051164d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051164d8"]])

export default __exports__